// extracted by mini-css-extract-plugin
export default {"icon":"Yt7Mg","text":"ALYEI","button":"EU2Zy","textButton":"puVsb","iconButton":"h16Xi","animated":"KKjdb","verticalAlign":"x9W+O"};